import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const AttrVfxIcon = React.memo<IconProps>(({ 
  className = '',
  size = 24,
  color = 'currentColor',
  onClick,
  strokeWidth
}) => (
  <BaseIcon
    className={className}
    size={size}
    color={color}
    onClick={onClick}
    viewBox="0 0 24 24"
    strokeWidth={strokeWidth}
  >
    <path d="M23.51 11.14L18.81 8.32001L15.94 0.650012C15.65 -0.199988 14.35 -0.199988 14.07 0.650012L11.19 8.32001L6.49001 11.14C5.85001 11.5 5.85001 12.5 6.49001 12.85L11.19 15.67L14.07 23.34C14.36 24.19 15.66 24.19 15.94 23.34L18.82 15.67L23.52 12.85C24.16 12.49 24.16 11.49 23.52 11.14H23.51ZM17.49 14.14C17.3 14.26 17.15 14.43 17.07 14.65L15.01 20.15L12.95 14.65C12.87 14.44 12.72 14.26 12.53 14.14L8.96001 12L12.53 9.86001C12.72 9.74001 12.87 9.57001 12.95 9.35001L15.01 3.85001L17.07 9.35001C17.15 9.56001 17.3 9.74001 17.49 9.86001L21.06 12L17.49 14.14Z" fill={color}/>
    <path d="M5 16C2.79 16 1 17.79 1 20C1 22.21 2.79 24 5 24C7.21 24 9 22.21 9 20C9 17.79 7.21 16 5 16ZM5 22C3.9 22 3 21.1 3 20C3 18.9 3.9 18 5 18C6.1 18 7 18.9 7 20C7 21.1 6.1 22 5 22Z" fill={color}/>
    <path d="M6 6.5C7.38071 6.5 8.5 5.38071 8.5 4C8.5 2.61929 7.38071 1.5 6 1.5C4.61929 1.5 3.5 2.61929 3.5 4C3.5 5.38071 4.61929 6.5 6 6.5Z" fill={color}/>
  </BaseIcon>
));

AttrVfxIcon.displayName = 'AttrVfxIcon';
